
import Vue from 'vue';
import SessionSoundsSettings from '@/components/SessionSoundsSettings.vue';
import { SNACKBAR_STATUS } from '@/constants/constants';
import { mapActions, mapState } from 'vuex';
import { db } from '@/firebase';

export default Vue.extend({
	name: 'SettingsWindowItem',
	props: {
		windowItemValue: { type: Number, required: true },
	},
	data () {
		return {
			updatingUserRunnitSettings: false,
		};
	},
	computed: {
		...mapState([
			'user',
			'toolbar',
		]),
	},
	methods: {
		...mapActions([
			'updateSnackbar',
		]),
		onBack () {
			this.$emit('on-settings-back');
		},
		async toggleAutoPlayThumbnails () {
			const val: boolean = !this._get(this.user, 'runnitSettings.autoPlayThumbnailsOff');
			try {
				if (!this.user || !this.user.id) {
					console.error('User not found');
					this.updateSnackbar({
						show: true,
						status: SNACKBAR_STATUS.ERROR,
						message: 'Unable to update auto play video preview setting',
					});
					return;
				}

				this.updatingUserRunnitSettings = true;
				const userRef = db.doc(`users/${this.user.id}`);
				await userRef.update({
					runnitSettings: {
						...(this.user.runnitSettings || {}),
						autoPlayThumbnailsOff: val
					}
				});

				this.updateSnackbar({
					show: true,
					status: SNACKBAR_STATUS.SUCCESS,
					message: val
						? 'Auto play video previews turned off'
						: 'Auto play video previews turned on',
				});
			} catch (e) {
				console.error('Error updating auto play video preview setting:', e);
				this.updateSnackbar({
					show: true,
					status: SNACKBAR_STATUS.ERROR,
					message: 'Failed to update auto play video preview setting',
				});
			} finally {
				this.updatingUserRunnitSettings = false;
			}
		},
		async toggleLibraryRoundedCorners () {
			const val: boolean = !this._get(this.user, 'runnitSettings.libraryRoundedCornersOff');
			try {
				if (!this.user || !this.user.id) {
					console.error('User not found');
					this.updateSnackbar({
						show: true,
						status: SNACKBAR_STATUS.ERROR,
						message: 'Unable to update library rounded corners setting',
					});
					return;
				}

				this.updatingUserRunnitSettings = true;
				const userRef = db.doc(`users/${this.user.id}`);
				await userRef.update({
					runnitSettings: {
						...(this.user.runnitSettings || {}),
						libraryRoundedCornersOff: val
					}
				});

				this.updateSnackbar({
					show: true,
					status: SNACKBAR_STATUS.SUCCESS,
					message: val
						? 'Library rounded corners turned off'
						: 'Library rounded corners turned on',
				});
			} catch (e) {
				console.error('Error updating library rounded corners setting:', e);
				this.updateSnackbar({
					show: true,
					status: SNACKBAR_STATUS.ERROR,
					message: 'Failed to update library rounded corners setting',
				});
			} finally {
				this.updatingUserRunnitSettings = false;
			}
		},
	},
	components: {
		SessionSoundsSettings,
	},
});
